import styled, { css } from "styled-components/macro";
import Action from "../Action";

export const primary = "primary";
export const secondary = "secondary";
export const tertiary = "tertiary";
export const primaryInverse = "primary-inverse";

export const ButtonPrimaryStyled = styled.button(({ theme }) => ({
  background: "linear-gradient(215.68deg, #87BAFF -80.44%, #005FC8 81.35%)",
  color: theme.color.neutral["08"],
  boxShadow: "0px 8px 16px rgba(0, 57, 186, 0.3)",
  "&:hover:not(:disabled)": {
    boxShadow: "0px 3px 8px 0px #0039BA52, 0px -1px 4px 0px #0039BA3D",
  },
  "&:active:not(:disabled)": {
    background: theme.color.brandPrimary.medium,
  },
}));

export const ButtonSecondaryStyled = styled.button(({ theme }) => ({
  background: "linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%)",
  color: theme.color.neutral["08"],
  boxShadow: "0px 8px 16px 0px rgba(243, 104, 0, 0.3)",
  "&:hover:not(:disabled)": {
    boxShadow: "0px 3px 8px 0px #F3680052, 0px -1px 4px 0px #F368003D",
  },
  "&:active:not(:disabled)": {
    background: theme.color.brandSecondary.medium,
  },
}));

export const ButtonSecondaryInverseStyled = styled.button(({ theme }) => ({
  background: theme.color.neutral["08"],
  color: theme.color.brandPrimary.light,
  boxShadow: "0px 8px 12px 0px #2D292629, 0px -2px 2px 0px #2D29260D",
  "&:hover:not(:disabled)": {
    boxShadow: "0px 6px 8px 0px #2D292629, 0px -2px 2px 0px #2D29260D",
  },
  "&:active:not(:disabled)": {
    color: theme.color.brandPrimary.medium,
  },
}));

export const ButtonPrimaryTransparentStyled = styled.button(({ theme }) => ({
  background: "transparent",
  color: theme.color.brandPrimary.light,
  border: `1px solid ${theme.color.brandPrimary.light} !important`,
  "&:hover:not(:disabled)": {
    background: theme.color.brandPrimary.light,
    color: theme.color.neutral["08"],
  },
  "&:active:not(:disabled)": {
    background: theme.color.brandPrimary.medium,
    color: theme.color.neutral["08"],
  },
}));

export const ButtonLinkStyled = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  background: "transparent",
  color: theme.color.brandPrimary.light,
  border: "none",
  textDecoration: "underline",
  padding: 0,
  cursor: "pointer",

  span: {
    textAlign: "start",
    flex: 1,
  },
}));

export const ButtonOutlined = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  background: "transparent",
  color: theme.color.brandPrimary.light,
  border: `1px solid ${theme.color.brandPrimary.light}`,
  padding: "12px 36px",
  borderRadius: "500px",
  cursor: "pointer",
  textDecoration: "none",

  "&:hover": {
    background: theme.color.brandPrimary.light,
    color: theme.color.neutral["08"],
  },

  span: {
    textAlign: "start",
    flex: 1,
  },
}));

export const ButtonIcon = styled.em`
  margin-right: 4px;
`;

export default styled(Action)`
  display: ${({ display = "inline-block" }) => display};
  min-width: 132px;
  text-align: center;
  padding: ${({ bSize }) => (bSize === "sm" ? "8px 24px" : "16px 36px")};
  margin: 16px 0;
  border: none;
  border-radius: 500px;
  cursor: pointer;
  text-decoration: none;
  &:active:not(:disabled) {
    box-shadow: none;
  }
  ${({ disabled }) =>
    disabled ? css({ cursor: "not-allowed", opacity: 0.4, border: 0 }) : ""}
`;
